import React from 'react';
import styles from './DestinationsList1.module.css';

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const DestinationsList1 = ({ destinations = [] }) => {
  return (
    <div className={styles.container}>
      <header className={styles.pageHeader}>
        <h1 className={styles.title}>Explore Destinations</h1>
        <p className={styles.subtitle}>
          Discover the world’s most breathtaking places with our curated travel guides.
        </p>
      </header>

      <div className={styles.grid}>
        {destinations.length > 0 ? (
          destinations.map((item, index) => {

            const fallbackImage =
              fallbackImages[index % fallbackImages.length];

            const imageUrl =
              item?.image && item.image.trim() !== ""
                ? item.image
                : fallbackImage;

            return (
              <div key={index} className={styles.card}>
                <div className={styles.imageWrapper}>
                  <img
                    src={imageUrl}
                    alt={item.name}
                    className={styles.image}
                    onError={(e) => {
                      e.target.src = fallbackImage;
                    }}
                  />

                  <div className={styles.overlay}>
                    <button className={styles.viewBtn}>
                      View Packages
                    </button>
                  </div>
                </div>

                <div className={styles.content}>
                  <h3 className={styles.name}>{item.name}</h3>
                  <p className={styles.description}>
                    {item.description ||
                      `Explore the beauty and culture of ${item.name}.`}
                  </p>
                </div>
              </div>
            );
          })
        ) : (
          <p className={styles.noData}>No destinations found.</p>
        )}
      </div>
    </div>
  );
};

export default DestinationsList1;